export const normalizeCareContinuationCategory = (category = '') => {
  const normalized = String(category || '').trim().toLowerCase();

  switch (normalized) {
    case 'daily':
    case 'dailylog':
    case 'note':
    case 'other':
    case 'log':
      return 'log';
    default:
      return normalized;
  }
};

const normalizeContinuationText = (value = '') => String(value || '')
  .toLowerCase()
  .replace(/https?:\/\/\S+/g, ' ')
  .replace(/[^a-z0-9]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

const BEHAVIOR_CONTINUATION_START_PATTERN = /^(?:she|he|they|then|after|with support|with prompting|needed support|sat out|rejoined|returned|calmed down|settled|before rejoining)\b/i;
const BEHAVIOR_QUICK_CONTINUATION_PATTERN = /\b(?:calmed down|settled|needed support|redirected|sat out|rejoined|returned to class|returned to group)\b/i;
const BEHAVIOR_REVIEW_CONTINUATION_PATTERN = /\b(?:calmed down|settled|needed support|redirected|sat out|rejoined|returned to class|returned to group|returned to activity)\b/i;

const FOOD_QUICK_CONTINUATION_PATTERN = /\b(?:finished(?:\s+her|\s+his|\s+their)?(?:\s+juice|\s+meal|\s+snack)?|rest of (?:her|his|their) meal|did not want the rest of (?:her|his|their) meal|drank most)\b/i;
const FOOD_REVIEW_FOLLOW_UP_PATTERN = /\b(?:ate most|only ate a few bites|few bites|a few bites|finished(?:\s+her|\s+his|\s+their)?(?:\s+juice|\s+meal|\s+snack)?|drank(?:\s+the)?(?:\s+juice|\s+water|\s+milk)|finished(?:\s+the)?(?:\s+juice|\s+water|\s+milk)|had(?:\s+the)?(?:\s+rest of|more of))\b/i;

const MEDICATION_CONTINUATION_PATTERN = /\b(?:no issues|no problems|without issues|tolerated well|as scheduled|went well)\b/i;
const MOOD_CONTINUATION_PATTERN = /\b(?:calmer|settled|regulated|improved|better|quiet at first but settled in)\b/i;
const SLEEP_REVIEW_CONTINUATION_PATTERN = /\b(?:slept quietly|rested quietly|stayed quiet|stayed on (?:her|his|their) mat|woke once|woke multiple times?)\b/i;

export const isCareBehaviorContinuationText = (text = '', { reviewGrouping = false } = {}) => {
  const normalized = normalizeContinuationText(text);
  if (!normalized) {
    return false;
  }

  const bodyPattern = reviewGrouping
    ? BEHAVIOR_REVIEW_CONTINUATION_PATTERN
    : BEHAVIOR_QUICK_CONTINUATION_PATTERN;

  return BEHAVIOR_CONTINUATION_START_PATTERN.test(normalized)
    || bodyPattern.test(normalized);
};

export const isQuickNoteFoodContinuationText = (text = '') => {
  const normalized = normalizeContinuationText(text);
  return normalized ? FOOD_QUICK_CONTINUATION_PATTERN.test(normalized) : false;
};

export const isReviewRowFoodContinuationText = (text = '') => {
  const normalized = normalizeContinuationText(text);
  return normalized
    ? FOOD_REVIEW_FOLLOW_UP_PATTERN.test(normalized) || FOOD_QUICK_CONTINUATION_PATTERN.test(normalized)
    : false;
};

export const isCareMedicationContinuationText = (text = '') => {
  const normalized = normalizeContinuationText(text);
  return normalized ? MEDICATION_CONTINUATION_PATTERN.test(normalized) : false;
};

export const isCareMoodContinuationText = (text = '') => {
  const normalized = normalizeContinuationText(text);
  return normalized ? MOOD_CONTINUATION_PATTERN.test(normalized) : false;
};

export const isReviewRowSleepContinuationText = (text = '') => {
  const normalized = normalizeContinuationText(text);
  return normalized ? SLEEP_REVIEW_CONTINUATION_PATTERN.test(normalized) : false;
};

export const isQuickNoteContinuationText = (category = '', text = '') => {
  switch (normalizeCareContinuationCategory(category)) {
    case 'behavior':
      return isCareBehaviorContinuationText(text);
    case 'food':
      return isQuickNoteFoodContinuationText(text);
    case 'medication':
      return isCareMedicationContinuationText(text);
    case 'mood':
    case 'log':
      return isCareMoodContinuationText(text);
    default:
      return false;
  }
};

export const isReviewRowContinuationText = (category = '', text = '') => {
  switch (normalizeCareContinuationCategory(category)) {
    case 'behavior':
      return isCareBehaviorContinuationText(text, { reviewGrouping: true });
    case 'food':
      return isReviewRowFoodContinuationText(text);
    case 'medication':
      return isCareMedicationContinuationText(text);
    case 'sleep':
      return isReviewRowSleepContinuationText(text);
    case 'mood':
    case 'log':
      return isCareMoodContinuationText(text);
    default:
      return false;
  }
};
